import { combineReducers } from 'redux';
import PanelsReducer from './reducer_panels';
import ActiveImageIndexReducer from './reducer_active_image';

const rootReducer = combineReducers({
	panels: PanelsReducer,
	activeImageIndex: ActiveImageIndexReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js